import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { useLanguage } from "@/hooks/useLanguage";
import { LanguageSelector } from "@/components/LanguageSelector";
import { Settings } from "lucide-react";

const SettingsSection = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      <Card className="p-2 sm:p-6 py-4 bg-white/5 backdrop-blur-sm border border-white/10">
        <div className="space-y-6">
          <div className="flex items-center gap-2">
            <Settings className="h-6 w-6 text-white" />
            <h2 className="text-2xl font-bold text-white">{t('settings.title')}</h2>
          </div>

          <div className="space-y-2">
            <Label className="text-white">{t('settings.language.label')}</Label>
            <LanguageSelector />
            <p className="text-sm text-gray-400">{t('settings.language.description')}</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SettingsSection;